import { Collapse, Navbar, NavbarToggler } from 'reactstrap';
import React, { useContext, useEffect, useState } from 'react';
import { Users } from './Users';
import { CompanySettings } from './CompanySettings'
import { Whistles } from './Whistles';
import { Whistle } from './Whistle';
import { DashboardNavBar } from './DashboardNavBar';
import { MyAccount } from './MyAccount';
import { TraksConsumer } from '../../traks';
import MeContext from '../../MeContext';
import { Loading } from '../../c/Loading';
import DashboardContext from '../../contexts/dashboardContext';
import WhistlesContext from '../../contexts/whistlesContext';
import { RenderIf } from '../../helpers/RenderIf';


export const ContentHeader = ({ children }) => {
	return (
		<div className="my-5">
			<h3 className="primary">
				{children}
			</h3>
		</div>
	)
}

const TabContent = ({ children }) => {
	const { activeTab } = useContext(DashboardContext)
	const { whistles } = useContext(WhistlesContext)
	if (whistles === undefined) {
		return (<>
			<Loading
				showLoading={true}
				inFront
			/>
		</>)
	}

	return React.Children.map(children, (child) =>
		<RenderIf condition={child.props.tabId === activeTab} >
			<div className="dashboard-content px-3">
				<TraksConsumer>
					{child}
				</TraksConsumer>
			</div>
		</RenderIf >
	)
};

const DashboardPage = () => {
	const { me } = useContext(MeContext);
	const userRoles = (me && me.roles) || [];
	const { whistles, getWhistles } = useContext(WhistlesContext)
	const [showLoading, setShowLoading] = useState(false)
	const [isMobileBurgerOpen, setIsMobileBurgerOpen] = useState(false)
	const [users, setUsers] = useState(undefined);
	const [user, setUser] = useState(undefined)
	const [meta, setMeta] = useState({ roles: [] });
	const toggle = () => setIsMobileBurgerOpen(!isMobileBurgerOpen);
	const { activeTab } = useContext(DashboardContext)

	useEffect(() => {
		setShowLoading(!showLoading)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [whistles])

	useEffect(() => {
		if (isMobileBurgerOpen)
			setIsMobileBurgerOpen(false)
		if (!whistles || activeTab === "Whistles") {
			getWhistles(me)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab, me])


	return (<>
		<Navbar className="d-block d-md-none" style={{ backgroundColor: `${isMobileBurgerOpen ? "#212838" : ""}` }}>
			<NavbarToggler className="mt-4" onClick={toggle} style={{ backgroundColor: "var(--new_sibilus_primary)" }} />
			<Collapse isOpen={isMobileBurgerOpen} navbar>
				<div className="bg_dark_blue vh-100 px-5">
					<TraksConsumer>
						<DashboardNavBar
							userRoles={userRoles}
						/>
					</TraksConsumer>
				</div>
			</Collapse>
		</Navbar>
		<div className="d-flex">
			<div className="bg_dark_blue d-none d-md-block d-flex flex-column-between h-100 position-fixed sidebar_width">
				<TraksConsumer>
					<DashboardNavBar
						isDesktop
						userRoles={userRoles}
					/>
				</TraksConsumer>
			</div>
		</div>
		<RenderIf condition={!isMobileBurgerOpen} >
			<TabContent>
				<Whistles tabId="Whistles" />
				<Whistle tabId="Whistle" />
				<Users
					users={users}
					setUsers={setUsers}
					meta={meta}
					setMeta={setMeta}
					tabId="Users" />
				<CompanySettings
					tabId="CompanySettings"
				/>
				<MyAccount
					user={user}
					setUser={setUser}
					tabId="MyAccount"
				/>
			</TabContent>
		</RenderIf>
	</>);
};

export default DashboardPage;
